var map = {
	"./account.js": 52971,
	"./assignment.js": 97839,
	"./classroom.js": 93276,
	"./dashboard.js": 25865,
	"./document.js": 76739,
	"./emis-support.js": 66234,
	"./event-calendar.js": 56214,
	"./exam-note.js": 93658,
	"./exam-statistic.js": 64845,
	"./exam-store.js": 60737,
	"./exercise-card.js": 76823,
	"./exercise-store-v2.js": 50389,
	"./exercise-store.js": 40954,
	"./game-galactic-warrior.js": 46908,
	"./grade.js": 19579,
	"./learning-config.js": 66731,
	"./library.js": 27919,
	"./ranking.js": 73451,
	"./school-exam-assign.js": 66820,
	"./school-exam-period-class-detail.js": 37818,
	"./school-exam-period-detail.js": 58292,
	"./school-exam-period-repair.js": 56983,
	"./school-exam-period.js": 26964,
	"./student-exam.js": 90979,
	"./student-exercise.js": 71052,
	"./student.js": 68966,
	"./subject.js": 95148,
	"./subjects.js": 92259,
	"./submit-exercise.js": 7211,
	"./survey.js": 8450,
	"./tag.js": 39824,
	"./teacher-exam-period.js": 21248,
	"./teacher-gif-card.js": 8277,
	"./teacher-ranking.js": 99165,
	"./teacher.js": 20616,
	"./topic.js": 50651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87087;